import { Box } from '@mui/material';
import { ResponsiveBar } from '@nivo/bar';
import ChartSection from '../shared/ChartSection';
import ChartTooltip from '../shared/ChartTooltip';
import useNivoTheme from '../shared/useNivoTheme';

const shortName = full => {
    const parts = (full || '').trim().split(/\s+/).filter(Boolean);
    if (parts.length === 0) return '—';
    if (parts.length === 1) return parts[0];
    return parts[0][0] + '. ' + parts[parts.length - 1];
};

export default function TopBottomTraders({ data }) {
    const { theme, colors } = useNivoTheme();
    if (!data?.top_10 || !data?.bottom_10) return null;

    const chartData = [
        ...data.top_10.map(m => ({ id: m.name, label: shortName(m.name), alpha: m.alpha })),
        ...[...data.bottom_10].reverse().map(m => ({ id: m.name, label: shortName(m.name), alpha: m.alpha })),
    ];

    const minAlpha = Math.min(...chartData.map(d => d.alpha));
    const maxAlpha = Math.max(...chartData.map(d => d.alpha));
    const pad = Math.max(2, (maxAlpha - minAlpha) * 0.05);

    return (
        <ChartSection
            id="top-bottom"
            title="Best vs Worst: How wide is the gap?"
            subtitle="Top 10 and bottom 10 traders by alpha vs S&P 500 (min 10 trades)"
        >
            <Box sx={{ height: 520 }}>
                <ResponsiveBar
                    data={chartData}
                    keys={['alpha']}
                    indexBy="id"
                    layout="horizontal"
                    margin={{ top: 10, right: 40, bottom: 50, left: 120 }}
                    padding={0.3}
                    borderRadius={3}
                    enableLabel
                    label={d => (d.value > 0 ? '+' : '') + d.value.toFixed(1) + '%'}
                    labelTextColor="#ffffff"
                    labelSkipWidth={36}
                    minValue={minAlpha - pad}
                    maxValue={maxAlpha + pad}
                    colors={({ data: d }) => (d.alpha >= 0 ? colors.success : colors.error)}
                    axisLeft={{
                        format: v => {
                            const row = chartData.find(r => r.id === v);
                            return row ? row.label : v;
                        },
                    }}
                    axisBottom={{
                        format: v => v + '%',
                        legend: 'Alpha vs S&P 500',
                        legendPosition: 'middle',
                        legendOffset: 38,
                    }}
                    markers={[
                        {
                            axis: 'x',
                            value: 0,
                            lineStyle: { stroke: colors.muted, strokeWidth: 1 },
                        },
                    ]}
                    tooltip={({ data: d }) => (
                        <ChartTooltip
                            title={d.id}
                            rows={[
                                {
                                    label: 'Alpha vs SPY',
                                    value: (d.alpha > 0 ? '+' : '') + d.alpha.toFixed(1) + '%',
                                    valueColor: d.alpha >= 0 ? 'success.main' : 'error.main',
                                },
                            ]}
                        />
                    )}
                    theme={theme}
                />
            </Box>
        </ChartSection>
    );
}
